import InputMask from "react-input-mask";
import { Row, Col, Card } from "react-bootstrap";

export default function PhoneInput(props,idx) {
    return (<Col xs={12} key={"row_service_" + idx} className="mb-2">
    <Card
      style={{ height: "100%" }}
      className="c-cursor-pointer"
      onClick={() => props.setNavigate(props.link)}
    >
      <Card.Body>
        <Row>
          <Col xs={2} className="pb-4">
            <span className="pb-4 c-logo c-squircle">{props.icon}</span>
          </Col>
          <Col xs={10}>
            <Row>
            <h6 className="mt-2 d-inline d-xl-flex m-0">
              <strong>{props.title}</strong>
            </h6>
            </Row>
            <Row>
            <small className="text-muted">{props.subtitle}</small>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>);
}

